// extracted by mini-css-extract-plugin
export default {"root":"Mfo2a","label":"_1bwHV","value":"lJlmQ"};